import { createLogger, Logger } from "@vp/ubik-logging";

const logger: Logger = createLogger({
  serviceName: "Price Platform Component",
  newrelicApplicationId: process.env.NEW_RELIC_APP_ID,
  newrelicLicenseKey: process.env.NEW_RELIC_LICENSE_KEY,
  microAgentLogLevel: "warn",
});

export { logger };
